import { Component } from '@angular/core';

@Component({
    selector: 'app-404',
    templateUrl: './404.component.html',
    styleUrls: ['./404.component.scss'],
    standalone: false
})
export class FourOFourComponent {

  constructor() {}

}
